import axios from 'axios';
import { auth } from 'src/Firebase';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_API,
});

axiosInstance.interceptors.request.use(
  async config => {
    const token = await auth.currentUser.getIdToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      config.headers.Version = "v3"
    }
    return config
  },
  error => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => Promise.reject(error),

);

export default axiosInstance;
 
